import { Sparkle } from "lucide-react";

const ITEMS = ["Test every 14 days", "Rebates on every test", "AI nurse on call 24/7", "Sex-positive education", "Built for creators & performers", "No shame. Just results."];

export const Marquee = () => (
  <section data-testid="editorial-marquee-container" className="relative py-10 sm:py-14 border-y border-white/10 overflow-hidden">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((t, i) => (
            <span key={t} className="flex items-center font-display font-bold text-4xl sm:text-6xl tracking-tight whitespace-nowrap px-6">
              <span className={i % 2 ? "outline-text" : ""}>{t}</span>
              <Sparkle className={`ml-12 ${i % 2 ? "text-[#5B95D6]" : "text-[#FF2A8D]"}`} size={30} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
